import { render, staticRenderFns } from "./ReviewHeader.vue?vue&type=template&id=81c91aea&scoped=true&"
import script from "./ReviewHeader.vue?vue&type=script&lang=ts&"
export * from "./ReviewHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewHeader.vue?vue&type=style&index=0&id=81c91aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c91aea",
  null
  
)

export default component.exports